export function setOrderPayloadState(state, payload) {
  return {
    ...state,
    orderPayload: payload
  };
}
